export default {
  metaTitle: '管理团购商品',
  pageTitle: '管理团购商品',
  radio1: '待审核',
  radio2: '尚未开始',
  radio3: '进行中',
  radio4: '已移除',
  radio5: '已拒绝',
  radio6: '已过期',
  atime: '申请时间',
  stime: '开始时间',
  placeholder1: 'Listing#',
  placeholder2: 'Sku#',
  placeholder3: '商品标题',
  btn1: '批量操作',
  btn2: '全选',
  btn3: '批量移除',
  btn4: '批量取消',
  columns1: 'listing ID',
  columns2: '图片',
  columns3: '标题',
  columns4: '店铺',
  columns5: '有效期(天)',
  columns6: '成团人数',
  columns7: '期望开始时间',
  columns8: '申请时间',
  columns9: 'SKU编号',
  columns10: '订单',
  columns11: '操作',
  buttonText: '售价',
  buttonCancle1: '移除',
  buttonCancle2: '取消',
  columnSpec1: 'Sku#',
  columnSpec2: '标题/规格',
  columnSpec3: '售价',
  columnSpec4: '库存',
  columnSpec5: '团购价',
  racktitle1: '团购价', // 原文：Price of group-on   (list#${params.row.listingId})
  racktitle2: 'listing ID',
  success1: '成功',
  content1: '您确定要取消吗',
  content2: '你确定要移除吗',
  content3: '你确定要批量移除吗',
  content4: '您确定要批量取消吗'
}
